import {
    ActionType,
    deleteUtiliztiondocumentAction,
    getUtilizationDocumentsAction,
    uploadUtilizationDocumentAction
} from "./actions";
import { createSlice } from "@reduxjs/toolkit";
import { UtilizationDocument } from "../../../domain/utilization_document/UtilizationDocument";

export type UtilizationDocumentState = Readonly<{
    utilizationDocuments: UtilizationDocument[],
    processing: number
}>;

const userInitialState: UtilizationDocumentState = {
    utilizationDocuments: [],
    processing: 0
};

const slice = createSlice({
    name: ActionType.base,
    initialState: userInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getUtilizationDocumentsAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                getUtilizationDocumentsAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { utilizationDocuments } = payload;
                    state.utilizationDocuments = utilizationDocuments;
                    state.processing -= 1;
                }
            )
            .addCase(
                getUtilizationDocumentsAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            ).addCase(
                uploadUtilizationDocumentAction.pending,
                (state) => {
                    state.processing += 1;
                }
            ).addCase(
                uploadUtilizationDocumentAction.fulfilled,
                (state) => {
                    state.processing -= 1;
                }
                
            ).addCase(
                uploadUtilizationDocumentAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            ).addCase(
                deleteUtiliztiondocumentAction.pending,
                (state) => {
                    state.processing += 1;
                }
            ).addCase(
                deleteUtiliztiondocumentAction.fulfilled,
                (state) => {
                    state.processing -= 1;
                }
            ).addCase(
                deleteUtiliztiondocumentAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const utilizationDocumentReducer = slice.reducer; 
